import React from "react";
import {
  SFCarouselContainer,
  SFCarouselSlide,
  SFSkeletonThumbnail,
  SFCarouselTitle,
  SFGridContainerItem,
  SFGridItem,
  SFStack,
  SFAvatarMenu,
} from "@sf-core";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { getThumbnailForSkillpath } from "../../helpers/getThumbnailFunction";

const CarouselComponent = ({
  title,
  items,
  onCardClick,
  getCardStats = () => ({}),
  getDropDownActions = () => ({}),
  hasHover = true,
  loading = false,
  showAvatar = false,
  userJobRoleTitle = null,
}) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  if (!Array.isArray(items)) return null;

  // Skeleton items for loading carousel state
  const skeletonItems = Array.from({ length: 6 }, (_, index) => index);

  return (
    <>
      <SFGridContainerItem>
        <SFGridItem xs={12}>
          <SFStack
            direction="row"
            alignItems="center"
            justifyContent="flex-start"
          >
            <SFCarouselTitle>{title} </SFCarouselTitle>
            <SFAvatarMenu
              showAvatar={showAvatar}
              getDropDownActions={getDropDownActions}
              title={userJobRoleTitle}
              isHomePage
            />
          </SFStack>
          <SFCarouselContainer autoWidth>
            {loading
              ? skeletonItems.map((_, index) => (
                <SFSkeletonThumbnail
                  key={index}
                  title={index == 0 ? t("homeScreen.carouselLoading") : ""}
                />
              ))
              : items.map((item, index) => (
                <SFCarouselSlide
                  key={`${item.title}-${index}`}
                  onClick={() => onCardClick(item, navigate)}
                  lazyLoad
                  hasHover={hasHover}
                  scaleOnHover
                  title={item.name ?? item.title}
                  // Change the mock skill path image to the actual thumbnail
                  image={item.isSkillPath ? getThumbnailForSkillpath(item.id) : item.thumbnail }
                  description={item.summary ?? item.description}
                  badge={getCardStats(item, t).badge}
                  stats={getCardStats(item, t).stats}
                  hoverStats={getCardStats(item, t).hoverStats}
                  indicator={getCardStats(item, t).indicator} //indicator for skill path
                />
              ))}
          </SFCarouselContainer>
        </SFGridItem>
      </SFGridContainerItem>
    </>
  );
};

export default CarouselComponent;
